export const HIDDEN_CLASS = 'gc-hidden';
export const PINNED_HEADER = 'gc-is-pinned';
export const ACTIVE_CLASS = 'gc-active';
export const RUN_ANIMATION_CLASS = 'gc-animate';
